import React, { useRef, useState } from "react"
import { Field, useField } from "formik"
import { FormContext } from "../Form"
import cx from "classnames"
import { useOnClickOutside } from "../../../../utility/hooks/useOnClickOutside"
import * as SelectRadix from '@radix-ui/react-select';

const Select = ({ label, name, values = {}, required, placeholder, onChange, disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [value, meta, helpers] = useField(name)
  // const current = value.value
  const ref = useRef()
  useOnClickOutside(ref, () => {
    setIsOpen(false)
    helpers.setTouched(true)
  })
  const error = meta.touched && meta.error

  return <FormContext.Consumer>
    {({ negative, big }) => {
      return <Field name={name} validate={(value) => {
        if (required && !value) {
          return required
        }
      }}>
        {({ field, meta }) => {
          return <div className="w-full">
            <SelectRadix.Select
              value={value.value}
              required={required}
              onOpenChange={newValue => {
                helpers.setTouched(true)
                setIsOpen(newValue)
              }}
              onValueChange={value => {
                helpers.setValue(value)
                if (typeof onChange === "function") {
                  onChange(value)
                }
              }}
            >
              {label && <label className={cx("block mb-0.5 font-medium text-small", {
                "text-midnight-10": !negative,
                "text-midnight-60": negative
              })}>{label}{required && "*"}</label>}
              <SelectRadix.Trigger
                className={cx("relative flex justify-between block w-full rounded border-2 ", {
                  "border-mid-night-50": !negative,
                  "border-midnight-50": negative,
                  "px-2 py-1.5": !big,
                  "px-2 py-3": big,
                  "border-blue-10 shadow-input-focus": isOpen && !negative,
                  "border-white shadow-input-focus-negative": isOpen && negative,
                  "!border-[#EA344A]": error,
                  "cursor-not-allowed bg-[#F5F6F7]": disabled,
                  "cursor-pointer bg-transparent": !disabled
                })}
                disabled={disabled}
              >
                <div className="flex w-full">
                  <SelectRadix.SelectValue placeholder={placeholder} className={cx("text-left", { "text-midnight-10": !negative, "border-midnight-50": negative })} />
                  <SelectRadix.Icon className="ml-auto items-self-center">
                    {isOpen && !negative && <SVGBlackOpen />}
                    {!isOpen && !negative && < SVGBlackClose />}
                    {isOpen && negative && <SVGWhiteOpen />}
                    {!isOpen && negative && < SVGWhiteClose />}
                  </SelectRadix.Icon>
                </div>
              </SelectRadix.Trigger>
              {error && <div className="text-[#EA344A] mt-0.5 text-small">{error}</div>}
              <SelectRadix.Portal>
                <SelectRadix.Content
                  position={"popper"}
                  className={cx("select-content data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1 border-2 border-midnight-40 bg-white rounded px-1 py-0.25 text-midnight-10 max-h-[240px] z-[50]")}
                >
                  <SelectRadix.Viewport className={cx("p-1 w-full h-[var(--radix-select-trigger-height)] w-full ")}>
                    {Object.keys(values).map((value, index) => <>
                      <SelectRadix.Item
                        className={cx("py-1.5 cursor-pointer text-medium px-1 focus:bg-blue-60 focus:outline-0")}
                        value={value}
                      >
                        <SelectRadix.ItemText>{values[value]}</SelectRadix.ItemText>
                      </SelectRadix.Item>
                      {index < Object.keys(values).length - 1 && <div className="h-0.25 bg-midnight-50" />}
                    </>)}
                  </SelectRadix.Viewport>
                </SelectRadix.Content>
              </SelectRadix.Portal>
            </SelectRadix.Select>
          </div>
        }}
      </Field>
    }}
  </FormContext.Consumer >
}

export default Select

const SVGBlackClose = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 9L12 15L18 9" stroke="#011642" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
</svg>

const SVGBlackOpen = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18 15L12 9L6 15" stroke="#011642" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
</svg>

const SVGWhiteClose = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 9L12 15L18 9" stroke="white" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
</svg>

const SVGWhiteOpen = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18 15L12 9L6 15" stroke="white" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
</svg>

